/**
 * ARTMiE recommendation feedback tracker.
 * Emits the signal the personalized re-rank model learns from: which recommended products were
 * SHOWN (impression / ranking event), CLICKED, and ADDED TO CART — on the native PDP
 * "recommended/alternative products" sections and our cart recommendations. Anonymous (a random
 * per-browser session id, no PII) and CONSENT-GATED (fires only when analytics consent is given).
 *
 * Reads config from window.AMH_CART_RECO = { market, apiBase }.
 */
(function () {
  "use strict";
  var CFG = window.AMH_CART_RECO || {};
  var MARKET = String(CFG.market || "").trim().toUpperCase();
  var API = String(CFG.apiBase || "").replace(/\/+$/, "");
  if (!MARKET || !API) return;

  // recommendation surfaces we learn from
  var REC_SEL = '[id*="recommended_products"], [id*="alternative_products"], [data-amh-cc="1"]';

  var _sid = null;
  function sid() {
    if (_sid) return _sid;
    try { var k = "amh_sid", v = localStorage.getItem(k); if (!v) { v = "s_" + Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem(k, v); } _sid = v; }
    catch (e) { _sid = "s_" + Math.random().toString(36).slice(2); }
    return _sid;
  }

  // Consent gate: Shopify's Customer Privacy API is authoritative but is NOT present until loaded
  // via Shopify.loadFeatures. So we load it, read analyticsProcessingAllowed(), and subscribe to
  // consent changes. Events raised before the decision is known are QUEUED, then flushed (if
  // allowed) or dropped. Privacy-first: unknown/declined → nothing is sent.
  var _consent = null, _queue = [];
  function _post(payload) {
    try {
      var body = JSON.stringify(Object.assign({ market: MARKET, user: sid(), session: sid() }, payload));
      var url = API + "/api/public/reco/feedback";
      // text/plain keeps this a CORS-simple request (no preflight) — sendBeacon can't preflight,
      // and the server parses the body as JSON regardless of content-type.
      if (navigator.sendBeacon && navigator.sendBeacon(url, new Blob([body], { type: "text/plain" }))) return;
      fetch(url, { method: "POST", headers: { "Content-Type": "text/plain" }, body: body, keepalive: true }).catch(function () {});
    } catch (e) { /* never break the storefront */ }
  }
  function _flush() { if (_consent) { while (_queue.length) _post(_queue.shift()); } else { _queue.length = 0; } }
  function send(payload) { if (_consent === true) { _post(payload); return; } if (_consent === false) return; _queue.push(payload); }
  function _fallback() {
    try {
      if (typeof window.__artmieConsent === "function") return !!window.__artmieConsent("analytics");
      if (window.__artmieConsent && typeof window.__artmieConsent === "object") return !!window.__artmieConsent.analytics;
      if (document.cookie.indexOf("artmie_consent=analytics") !== -1 || document.cookie.indexOf("artmie_consent=all") !== -1) return true;
    } catch (e) {}
    return false;
  }
  (function initConsent() {
    try {
      var sp = window.Shopify && window.Shopify.customerPrivacy;
      if (sp && typeof sp.analyticsProcessingAllowed === "function") { _consent = !!sp.analyticsProcessingAllowed(); _flush(); return; }
      if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
        window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function () {
          var s = window.Shopify && window.Shopify.customerPrivacy;
          _consent = !!(s && s.analyticsProcessingAllowed && s.analyticsProcessingAllowed()) || (!s && _fallback());
          _flush();
          try { if (s && s.subscribe) s.subscribe("visitorConsentCollected", function (ev) { _consent = !!(ev && ev.analyticsAllowed); _flush(); }); } catch (e) {}
        });
        return;
      }
    } catch (e) {}
    _consent = _fallback(); _flush();
  })();

  function placementOf(sec) {
    if (sec.getAttribute && sec.getAttribute("data-amh-cc") === "1") return "cart";
    var id = sec.id || "";
    if (id.indexOf("alternative_products") > -1) return "pdp-alt";
    if (id.indexOf("recommended_products") > -1) return "pdp-rec";
    return "reco";
  }
  function handleOf(a) { if (!a) return null; var h = (a.getAttribute("href") || "").split("/products/")[1]; return h ? h.split("?")[0].split("#")[0].replace(/\/$/, "") : null; }
  function itemsOf(sec) { var out = [], set = {}; sec.querySelectorAll('a[href*="/products/"]').forEach(function (a) { var h = handleOf(a); if (h && !set[h]) { set[h] = 1; out.push(h); } }); return out; }

  var ranks = new WeakMap(); // section -> ranking id (ties clicks to the impression)
  function impress(sec) {
    if (ranks.has(sec)) return ranks.get(sec);
    var items = itemsOf(sec);
    if (!items.length) return null;
    var rid = "r_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    ranks.set(sec, rid);
    send({ type: "impression", items: items, ranking: rid, placement: placementOf(sec) });
    return rid;
  }

  var io = ("IntersectionObserver" in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { impress(en.target); io.unobserve(en.target); } });
  }, { threshold: 0.3 }) : null;

  function scan() {
    document.querySelectorAll(REC_SEL).forEach(function (sec) { if (ranks.has(sec)) return; if (io) io.observe(sec); else impress(sec); });
  }

  // click + add-to-cart, via delegation (works for dynamically injected sections too)
  document.addEventListener("click", function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var sec = t.closest(REC_SEL);
    if (!sec) return;
    var rid = impress(sec); // ensure the impression is on record before the interaction
    var link = t.closest('a[href*="/products/"]');
    var card = t.closest('product-card, .resource-list__item, li');
    var handle = handleOf(link) || (card ? handleOf(card.querySelector('a[href*="/products/"]')) : null);
    if (!handle) return;
    var addBtn = t.closest('button[name="add"], add-to-cart-component, [data-add-to-cart]');
    if (addBtn) send({ type: "add_to_cart", item: handle, ranking: rid, placement: placementOf(sec) });
    else if (link) send({ type: "click", item: handle, ranking: rid, placement: placementOf(sec) });
  }, true);

  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(scan, 250); }
  function boot() {
    scan();
    try { new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true }); } catch (e) { /* ignore */ }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
